<div class="flex flex-col gap-1">
  <label *ngIf="label" [attr.for]="inputId" class="block text-[14px] font-normal text-nowrap text-[#444955]">
    {{label}}
    <span *ngIf="required" class="text-danger-500"> * </span>
  </label>
  <div class="relative inline-block w-full" #datePickerContainer>
    <div class="relative">
      <div
        class="group flex items-center"
        [ngClass]="[
      hasError ? 'outline outline-2 -outline-offset-2 outline-danger-500' : 'focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-primary-500',
      disabled ? 'bg-secondary-200 pointer-events-none cursor-not-allowed' : '',
      !containerStyle ? 'border border-gray-300 rounded-lg shadow-sm' : ''
     ]"
        [attr.style]="containerStyle"
        (keydown)="handleContainerKeyDown($event)"
      >
        <!-- Calendar icon -->
        <button type="button" class="pl-5 pr-3 cursor-pointer flex items-center justify-center" (click)="toggleCalendar()" (keydown)="onCalendarIconKeyDown($event)" niTooltip [tooltip]="inputValue" [attr.aria-label]="'Open calendar'">
          <NiIcon icon="linear_calendar" [class]="leadingIconClass" />
        </button>

        <input
          #inputElement
          [id]="inputId"
          type="text"
          [placeholder]="placeholder"
          [value]="inputValue"
          [disabled]="disabled"
          [readOnly]="!allowInput"
          niTooltip
          [tooltip]="inputValue"
          (click)="toggleCalendar()"
          (input)="onInputChange($event)"
          [attr.style]="inputStyle"
          class="peer w-full outline-none focus:ring-0 flex-1"
          [ngClass]="{
            'py-[9px] rounded-lg sm:text-sm': !inputStyle,
            'cursor-pointer': !allowInput || disabled === false,
            'cursor-text': allowInput && !disabled,
            'bg-secondary-700 border-secondary-600': disabled && theme === 'dark',
            'border-secondary-300 focus:border-primary-500 border-0': !disabled && theme === 'light' && !inputStyle,
            'border-secondary-600 bg-secondary-800 text-secondary-200 focus:border-primary-400': !disabled && theme === 'dark' && !inputStyle,
            'border-0': !!inputStyle
          }"  
        />

        <!-- Clear button -->
        <button
          type="button"
          tabindex="-1"
          *ngIf="clearable && (selectedDate || (rangeMode && (startDate || endDate)))"
          class="w-5 h-5 rounded-full bg-primary-500 hover:bg-primary-600 flex items-center justify-center transition-all duration-150 cursor-pointer relative overflow-hidden mr-4"
          [attr.aria-label]="'Clear date'"
          (click)="rangeMode ? clearRangeDate($event) : clearDate($event); startRipple($event, 'clear')"
        >
            <NiIcon [icon]="clearIcon" [class]="clearIconClass"></NiIcon>
            <span
              *ngIf="rippleState.show && rippleState.target === 'clear'"
              class="absolute inset-0 bg-secondary-400 rounded-full opacity-25"
              [@rippleAnimation]
            ></span>
        </button>
      </div>
    </div>

    <!-- Wheel style popup -->
    <div
      *ngIf="(isOpen || inline) && !disabled"
      [@calendarAnimation]
      [ngClass]="
        inline
          ? 'absolute z-50 transform transition-all duration-200 ease-in-out'
          : 'fixed z-[55] flex items-center justify-center'
      "
      [style.top]="inline ? (calendarPosition === 'above' ? 'auto' : '100%') : '0'"
      [style.bottom]="inline ? (calendarPosition === 'above' ? '100%' : 'auto') : '0'"
      [style.left]="inline ? '0px' : '0'"
      [style.right]="inline ? null : '0'"
      [style.width]="inline ? null : '100%'"
      [style.height]="inline ? null : '100%'"
      [style.margin-top]="inline ? (calendarPosition === 'below' ? '8px' : '0') : null"
      [style.margin-bottom]="inline ? (calendarPosition === 'above' ? '8px' : '0') : null"
      (click)="!inline && closeCalendar($event)"
      (keydown)="handleOverlayKeyDown($event)"
    >
      <div
        class="w-[95vw] max-w-[600px] sm:w-[600px] sm:max-w-[700px] md:w-[700px] max-h-[90vh] sm:max-h-[85vh] min-h-[50vh] sm:min-h-[400px] md:min-h-[480px] rounded-[16px] sm:rounded-[32px] bg-white text-gray-900 shadow-[0_25px_55px_rgba(0,0,0,0.22)] mx-2 sm:mx-0 flex flex-col overflow-hidden"
        style="font-family: 'Poppins', 'Inter', 'Segoe UI', sans-serif;"
        [ngClass]="inline ? '' : 'relative'"
        [style.margin]="inline ? null : 'auto'"
        (click)="$event.stopPropagation()"
        (keydown)="handleOverlayKeyDown($event)"
      >
        <div class="flex flex-row justify-between gap-1 sm:gap-0 pl-1 pr-1 sm:pl-2 sm:pr-8 py-3 sm:py-6 md:py-10 flex-1 min-h-0">
          <div class="flex-1 text-center flex flex-col min-h-0">
            <p class="text-xs sm:text-sm font-semibold uppercase tracking-[0.2em] sm:tracking-[0.3em] text-gray-400 px-1">Day</p>
            <div class="relative mt-2 sm:mt-3 overflow-visible flex-1 min-h-0 flex flex-col">
              <select
                #dayWheelSelect
                class="sr-only"
                [value]="getTempDay()"
                (change)="selectTempDay(+$any($event.target).value)"
                [attr.aria-label]="'Day selector'"
              >
                <option
                  *ngFor="let day of dayOptions"
                  [value]="day"
                  [selected]="day === getTempDay()"
                >
                  {{ padZero(day) }}
                </option>
              </select>
              <div class="date-picker-scroll h-full max-h-[50vh] sm:max-h-[400px] overflow-y-scroll space-y-1 pb-[30px] pt-[30px] pr-[12px] pl-[12px] sm:pb-[40px] sm:pt-[40px] sm:pr-[40px] sm:pl-[40px] border-r-0 sm:border-r border-gray-100 relative z-20" #dayWheel [attr.aria-hidden]="'true'">
                <button
                  type="button"
                  *ngFor="let day of dayOptions"
                  class="flex w-full snap-center items-center justify-center rounded-xl py-1.5 sm:py-2 text-[18px] sm:text-[22px] font-semibold transition-all duration-300 ease-in-out min-h-[36px] sm:min-h-[44px]"
                  [ngClass]="{
                    'border-2 border-primary-500 text-primary-500 shadow-inner scale-105': day === getTempDay(),
                    'text-gray-700 hover:text-[#FF6400]': day !== getTempDay()
                  }"
                  [attr.data-option-index]="day - 1"
                  (click)="selectTempDay(day)"
                  [attr.aria-hidden]="'true'"
                >
                  {{ padZero(day) }}
                </button>
              </div>
            </div>
          </div>

          <div class="flex-1 text-center flex flex-col min-h-0">
            <p class="text-xs sm:text-sm font-semibold uppercase tracking-[0.2em] sm:tracking-[0.3em] text-gray-400 px-1">Month</p>
            <div class="relative mt-2 sm:mt-3 overflow-visible flex-1 min-h-0 flex flex-col">
              <select
                #monthWheelSelect
                class="sr-only"
                [value]="getTempMonth()"
                (change)="selectTempMonth(+$any($event.target).value)"
                [attr.aria-label]="'Month selector'"
              >
                <option
                  *ngFor="let month of months; let i = index"
                  [value]="i"
                  [selected]="i === getTempMonth()"
                >
                  {{ month.slice(0, 3) }}
                </option>
              </select>
              <div class="date-picker-scroll h-full max-h-[50vh] sm:max-h-[400px] overflow-y-scroll space-y-1 pb-[30px] pt-[30px] pr-[12px] pl-[12px] sm:pb-[40px] sm:pt-[40px] sm:pr-[40px] sm:pl-[40px] border-r-0 sm:border-r border-gray-100 relative z-20" #monthWheel [attr.aria-hidden]="'true'">
                <button
                  type="button"
                  *ngFor="let month of months; let i = index"
                  class="flex w-full snap-center items-center justify-center rounded-xl py-1.5 sm:py-2 text-[18px] sm:text-[22px] font-semibold transition-all duration-300 ease-in-out min-h-[36px] sm:min-h-[44px]"
                  [ngClass]="{
                    'border-2 border-primary-500 text-primary-500 shadow-inner scale-105': i === getTempMonth(),
                    'text-gray-700 hover:text-[#FF6400]': i !== getTempMonth()
                  }"
                  [attr.data-option-index]="i"
                  (click)="selectTempMonth(i)"
                  [attr.aria-hidden]="'true'"
                >
                  {{ month.slice(0, 3) }}
                </button>
              </div>
            </div>
          </div>

          <div class="flex-1 text-center flex flex-col min-h-0">
            <p class="text-xs sm:text-sm font-semibold uppercase tracking-[0.2em] sm:tracking-[0.3em] text-gray-400 px-1">Year</p>
            <div class="relative mt-2 sm:mt-3 overflow-visible flex-1 min-h-0 flex flex-col">
              <select
                #yearWheelSelect
                class="sr-only"
                [value]="getTempYear()"
                (change)="selectTempYear(+$any($event.target).value)"
                [attr.aria-label]="'Year selector'"
              >
                <option
                  *ngFor="let year of yearOptions; let yi = index"
                  [value]="year"
                  [selected]="year === getTempYear()"
                >
                  {{ year }}
                </option>
              </select>
              <div class="date-picker-scroll h-full max-h-[50vh] sm:max-h-[400px] overflow-y-scroll space-y-1 pb-[30px] pt-[30px] pr-[12px] pl-[12px] sm:pb-[40px] sm:pt-[40px] sm:pr-[40px] sm:pl-[40px] border-r-0 relative z-20" #yearWheel [attr.aria-hidden]="'true'">
                <button
                  type="button"
                  *ngFor="let year of yearOptions; let yi = index"
                  class="flex w-full snap-center items-center justify-center rounded-xl py-1.5 sm:py-2 text-[18px] sm:text-[22px] font-semibold transition-all duration-300 ease-in-out min-h-[36px] sm:min-h-[44px]"
                  [ngClass]="{
                    'border-2 border-primary-500 text-primary-500 shadow-inner scale-105': year === getTempYear(),
                    'text-gray-700 hover:text-[#FF6400]': year !== getTempYear()
                  }"
                  [attr.data-option-index]="yi"
                  (click)="selectTempYear(year)"
                  [attr.aria-hidden]="'true'"
                >
                  {{ year }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="flex items-center justify-end border-t border-gray-100 px-4 sm:px-6 py-3 sm:py-4">
          <button
            type="button"
            class="rounded-lg bg-[#FF6400] px-5 sm:px-6 py-2 text-[16px] sm:text-[18px] font-bold font-archivo text-white transition hover:bg-[#ff7c26] w-full sm:w-auto"
            (click)="confirmTempSelection($event)"
          >
            Ok
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
